/** Tabs of the export mode */
export enum ExportModeTab {
  pointCloud = "pointCloud",
  orthophoto = "orthophoto",
  scans = "scans",
}

/**
 * Determines if a tab requires a point cloud to function
 *
 * @param tab - The export mode tab to check
 * @returns true if the tab requires a point cloud
 */
function doesTabRequirePointCloud(tab: ExportModeTab): boolean {
  return tab === ExportModeTab.pointCloud || tab === ExportModeTab.orthophoto;
}

/**
 * Gets all tabs that require a point cloud
 *
 * @returns Array of tabs that require a point cloud
 */
export function getTabsRequiringPointCloud(): ExportModeTab[] {
  return Object.values(ExportModeTab).filter(doesTabRequirePointCloud);
}
